import { growthbook } from 'config/growthbook/config';
import { FeatureFlags } from 'config/growthbook/featureFlags';

// CLEANUP-L1S-1606: remove selector and its consumers' legacy branches after 100% rollout
export const selectIsNewQuestionsEndpointEnabled = (): boolean =>
  growthbook.isOn(FeatureFlags.NEW_QUESTIONS_ENDPOINT);
